<template>
  <footer class="footer-mini" ref="footerRef">
    <div class="footer-container" ref="contentRef">
      
      <!-- LADO IZQUIERDO: BRANDING & COPYRIGHT -->
      <div class="footer-left">
        <h2 class="footer-logo">My Evento <span>Digital</span></h2>
        <p class="footer-copyright">&copy; 2026 &middot; Todos los derechos reservados.</p>
      </div>

      <!-- CENTRO: SELECTORES COMPACTOS -->
      <div class="footer-center">
        <div class="select-wrapper">
          <select aria-label="País">
            <option>México | MXN $</option>
            <option>USA | USD $</option>
            <option>España | EUR €</option>
          </select>
        </div>
        <div class="select-wrapper">
          <select aria-label="Idioma">
            <option>Español</option>
            <option>English</option>
          </select>
        </div>
      </div>

      <!-- LADO DERECHO: LINKS & CONTACTO -->
      <div class="footer-right">
  <a
  href="https://wa.me/16128072269?text=Hola,%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20las%20invitaciones%20digitales"
  target="_blank"
  rel="noopener"
  class="contact-button"
>    <span class="pulse-dot"></span> Contactar Agente
        </a>
      </div>

    </div>
  </footer>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'FooterSimpleElegante',
  setup() {
    const footerRef = ref(null)
    const contentRef = ref(null)

    onMounted(() => {
      gsap.from(contentRef.value.children, {
        opacity: 0,
        y: 20,
        duration: 1,
        stagger: 0.15,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: footerRef.value,
          start: 'top 95%',
          once: true
        }
      })
    })

    return { footerRef, contentRef }
  }
}
</script>

<style scoped>
/* CONTENEDOR MINI - DISEÑO ULTRA COMPACTO */
.footer-mini {
  background-color: #fffefb;
  color: #2b2927;
  padding: 35px 0;
  border-top: 1px solid rgba(212, 163, 115, 0.15);
  overflow: hidden;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 4%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

/* LADO IZQUIERDO: LOGO Y COPY */
.footer-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-logo {
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  font-size: 1.4rem;
  margin: 0;
}

.footer-logo span {
  font-style: italic;
  font-weight: 400;
  color: #e293a0;
}

.footer-copyright {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.78rem;
  color: #8c8580;
  margin: 0;
}

/* CENTRO: COMBOS ELEGANTES */
.footer-center {
  display: flex;
  gap: 10px;
}

.select-wrapper {
  position: relative;
}

.select-wrapper::after {
  content: '▾';
  font-size: 0.65rem;
  color: #bfa18f;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

select {
  padding: 6px 25px 6px 12px;
  border: 1px solid rgba(191, 161, 143, 0.25);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
  border-radius: 20px;
  background: #ffffff;
  color: #4a4542;
  cursor: pointer;
  appearance: none;
  transition: all 0.3s ease;
}

select:hover {
  border-color: #e293a0;
}

select:focus {
  outline: none;
  border-color: #e293a0;
}

/* LADO DERECHO: LINKS */
.footer-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.legal-link {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.78rem;
  color: #6a6561;
  text-decoration: none;
  transition: color 0.3s ease;
}

.legal-link:hover {
  color: #e293a0;
}

/* BOTÓN DE WHATSAPP COMPACTO DE ALTO IMPACTO */
.contact-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(226, 147, 160, 0.06);
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid rgba(226, 147, 160, 0.2);
  font-family: 'Montserrat', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  color: #e293a0;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-button:hover {
  background: rgba(226, 147, 160, 0.12);
  transform: translateY(-1px);
}

.pulse-dot {
  width: 6px;
  height: 6px;
  background-color: #e293a0;
  border-radius: 50%;
  position: relative;
}

.pulse-dot::after {
  content: '';
  width: 100%;
  height: 100%;
  background-color: #e293a0;
  border-radius: 50%;
  position: absolute;
  inset: 0;
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(2.5); opacity: 0; }
}

/* RESPONSIVE: MÓVIL SÚPER ADAPTADO */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
    gap: 15px;
    padding: 25px 0;
  }

  .footer-left {
    flex-direction: column;
    gap: 5px;
  }

  .footer-right {
    flex-direction: column;
    gap: 12px;
  }
}
</style>